import React from 'react';
import { View } from 'react-native';

import { map as _map } from 'lodash';
import PropTypes from 'prop-types';

import { getFormattedDate as formatDate } from '../../../Utils/Getter';
import { PercentageUsageCard } from '../../Components';

import styles from './UnfilteredCategoriesUsage.Styles';

function UnfilteredCategoriesUsage({ usage, images, ...props }) {
  const renderList = () => {
    return _map(usage, usageItem => {
      return (
        <PercentageUsageCard
          {...usageItem}
          title={usageItem.period}
          date={formatDate(usageItem)}
          images={images}
          containerStyle={styles.itemContainerStyle}
        />
      );
    });
  };

  return <View style={styles.containerStyle}>{renderList()}</View>;
}

UnfilteredCategoriesUsage.propTypes = {
  usage: PropTypes.arrayOf(
    PropTypes.shape({
      period: PropTypes.string,
      startDate: PropTypes.string,
      endDate: PropTypes.string,
      usageData: PropTypes.array,
    }),
  ),
  images: PropTypes.object,
};

export default UnfilteredCategoriesUsage;
